module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo2-6bfa6a9b25f2f587cc1706215f37b9ef.jpg";